// src/aws-exports.js

// This file defines your AWS Amplify backend configuration.
// It contains details about your Cognito User Pool, which Amplify uses to
// authenticate users and manage sessions.

const awsExports = {
  Auth: {
    // The 'Cognito' block is crucial for Amplify v6+ to correctly identify
    // and initialize your Cognito User Pool as the token provider.
    Cognito: {
      userPoolId:         'ap-south-1_MSQMDBBDm',     // Your Cognito User Pool ID
      userPoolClientId:   '6ns99d6n7cp3qhodligs7jai24', // Your Cognito App Client ID (Note: Client ID, not Web Client ID in this config)
      region:             'ap-south-1',              // Your AWS region

      // OPTIONAL: If you plan to use Cognito Hosted UI, social logins (Google, Facebook),
      // or federated identities, you would uncomment and configure the 'loginWith.oauth' block here.
      // Make sure 'domain', 'scopes', and 'redirectSignIn/redirectSignOut' URLs EXACTLY match
      // what you've configured in your Cognito User Pool's App client settings in the AWS Console.
      /*
      loginWith: {
        oauth: {
          domain:          'your-prefix.auth.ap-south-1.amazoncognito.com', // Replace with your actual Cognito domain
          scopes:          ['openid', 'email', 'profile'], // Required OAuth scopes
          redirectSignIn:  ['http://localhost:3000/', 'https://yourdomain.com/'], // Your redirect URLs after sign-in
          redirectSignOut: ['http://localhost:3000/', 'https://yourdomain.com/'], // Your redirect URLs after sign-out
          responseType:    'code' // Or 'token' depending on your flow (code is generally recommended for security)
        }
      }
      */
      // You can also specify authenticationFlowType here if needed for custom flows,
      // but USER_SRP_AUTH is usually the default and handled implicitly if not specified.
      // authenticationFlowType: 'USER_SRP_AUTH',
    }
  }
};

// This line is CRUCIAL for awsconfig to be importable as a default export
export default awsExports;
